import { BaseProps } from '@types';

export enum LoaderSizes {
  /**
   * @desc 20px
   */
  xs = 'xs',
  /**
   * @desc 24px. После обновления станет 20px
   */
  s = 's',
  /**
   * @desc 54px. После обновления станет 24px
   */
  m = 'm',
  /**
   * @desc 100px. После обновления станет 34px
   */
  l = 'l',
}

export enum LoaderColors {
  /**
   * @desc TextAndIconColors.labelBrand
   */
  brand = 'brand',
  /**
   * @desc TextAndIconColors.interfaceTertiary
   */
  dark = 'dark',
  /**
   * @desc TextAndIconColors.interfaceOnsurface
   */
  light = 'light',
}

export interface LoaderProps extends BaseProps {
  // На практике `BaseProps` должен содержать `className`, но типы из `@types` могут
  // не резолвиться в отдельных режимах линтинга/IDE. Явно добавляем, чтобы
  // компонент типизировался предсказуемо.
  className?: string;
  /**
   * Loader size
   * @default LoaderSizes.m
   */
  size?: LoaderSizes;
  /**
   * Loader color
   * @default LoaderColors.brand
   */
  color?: LoaderColors;
  inline?: boolean;
  loaderInsideButton?: boolean;
  noMargin?: boolean;
}
